package pages.projects


import JQid
import kotlinx.browser.document
import kotlinx.html.style
import kotlinx.html.*
import kotlinx.html.js.header
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement

inline fun TagConsumer<HTMLElement>.projectsPage()  = div("main"){

   document.querySelector("div.main")?.remove()

   +"hi"


}